import { UseFormReturn } from 'react-hook-form';

import { QuickQuoteInputs } from '../../types';
import { StopsSection as StopsSectionLTL } from '../StopsSection';

interface StopsSectionProps {
  formMethods: UseFormReturn<QuickQuoteInputs, any, QuickQuoteInputs>;
  hasAddedQuoteDates: boolean;
}

export function StopsSection({
  formMethods,
  hasAddedQuoteDates,
}: StopsSectionProps) {
  return (
    <StopsSectionLTL
      formMethods={formMethods}
      hasAddedQuoteDates={hasAddedQuoteDates}
      showDatesAboveStops={true}
    />
  );
}
